import React, {Component} from 'react'
import {NavBar,InputItem,Toast} from 'antd-mobile';
import {complete} from '../../../service/loginService';
import './style.less';
export default class ResetPwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwd: '',
            check:true,
            onOff:false
        };
    }


     //监听用户输入手机号的位数判断按钮的颜色
     phoneChange = (value) => {
        this.setState({passwd: value});
        if(value.replace(/\s/ig, '').length >= 6 ){
            this.setState({check: false});
        }else if(value.replace(/\s/ig, '').length < 6){
            this.setState({check: true});
        }

    };
    ok = () => {
        this.setState({
            onOff:!this.state.onOff
        })
    };
    setPwd=()=>{
        let params = {
            "phone":this.props.location.state.phone,
            "passwd":this.state.passwd
        };
        complete(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.info("重置成功！",2,()=>this.props.history.push("/login"))
                    
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    render() {
        return (
            <div className="resetPwd">
                <NavBar
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui"> </i>}
                    onLeftClick={() => this.props.history.goBack()}
                >
                </NavBar>
                <div className="regInfo">
                    <div className="identity">请设置密码</div>
                    <div className="checkMobile">登录密码用于手机司机管理登录</div>
                    <div className="inputMobile">密码</div>
                <InputItem
                    type={this.state.onOff == false ? "password":"text"}
                    maxLength={20}
                    placeholder="请输入密码"
                    value={this.state.passwd}
                    onChange={this.phoneChange}
                    extra={this.state.onOff ? <i className="icon iconfont iconzhengyan" onClick={this.ok}></i> : <i className="icon iconfont iconbiyan" onClick={this.ok}></i>}
                />
                <div className="downTime">需6～20位字母和数字</div>
                <div className="submitBox">
                    <button disabled={this.state.check} onClick={()=>this.setPwd()}>完成</button>
                </div>
            </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Login/SetPwd/index.js